import Image from "next/image";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/app/components/shadcn/breadcrumb";

export interface PageHeroBreadcrumbItem {
  title: string;
  url?: string;
}

interface PageHeroProps {
  /** Sayfanın ana başlığı */
  title: string;
  /** Başlığın altındaki açıklama metni */
  description?: string;
  /** Arka plan fotoğraf URL'i — verilmezse düz koyu arka plan kullanılır */
  imageUrl?: string;
  /** Küçük üst etiket (opsiyonel, örn. "Mişaroğlu Tekstil · Tozlu.com") */
  eyebrow?: string;
  /** Breadcrumb öğeleri — son öğe otomatik olarak aktif (link yok) kabul edilir */
  breadcrumbs?: PageHeroBreadcrumbItem[];
}

const PageHero = ({
  title,
  description,
  imageUrl,
  eyebrow,
  breadcrumbs,
}: PageHeroProps) => {
  return (
    <div className="relative overflow-hidden bg-black min-h-[460px] flex items-end">
      {/* Background image */}
      {imageUrl && (
        <Image
          src={imageUrl}
          alt={title}
          fill
          className="object-cover opacity-40"
          priority
        />
      )}

      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/55 to-transparent" />

      <div className="relative z-10 container-minify pb-14 pt-28 w-full">
        {/* Breadcrumb */}
        {breadcrumbs && breadcrumbs.length > 0 && (
          <div className="mb-6">
            <Breadcrumb>
              <BreadcrumbList>
                {breadcrumbs.map((item, index) => {
                  const isLast = index === breadcrumbs.length - 1;
                  return (
                    <div key={index} className="flex items-center">
                      <BreadcrumbItem>
                        {isLast || !item.url ? (
                          <BreadcrumbPage className="text-gray-200">
                            {item.title}
                          </BreadcrumbPage>
                        ) : (
                          <BreadcrumbLink
                            href={item.url}
                            className="text-gray-400 hover:text-white"
                          >
                            {item.title}
                          </BreadcrumbLink>
                        )}
                      </BreadcrumbItem>
                      {!isLast && (
                        <BreadcrumbSeparator className="text-gray-600" />
                      )}
                    </div>
                  );
                })}
              </BreadcrumbList>
            </Breadcrumb>
          </div>
        )}

        {/* Eyebrow */}
        {eyebrow && (
          <p className="text-xs uppercase tracking-[0.2em] text-gray-400 font-medium mb-4">
            {eyebrow}
          </p>
        )}

        {/* Title */}
        <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-5 max-w-2xl">
          {title}
        </h1>

        {/* Description */}
        {description && (
          <p className="text-gray-300 text-base max-w-lg leading-relaxed">
            {description}
          </p>
        )}
      </div>
    </div>
  );
};

export default PageHero;